/**
 * export namespace
 */
export const NAMESPACE = 'INIT';
/**
 * GET_WEBCHAT
 */
export const GET_WEBCHAT = `webchat/${NAMESPACE}/GET_WEBCHAT`;

/**
 * GET_WEBCHAT_SUCCESS
 */
export const GET_WEBCHAT_SUCCESS = `webchat/${NAMESPACE}/GET_WEBCHAT_SUCCESS`;

/**
 * GET_WEBCHAT_FAILED
 */
export const GET_WEBCHAT_FAILED = `webchat/${NAMESPACE}/GET_WEBCHAT_FAILED`;

/**
 * API_INIT_WEBCHAT
 */
export const API_INIT_WEBCHAT_PATH = '/gms/chat/tobisales/';
